import { z } from 'zod'
import { communityObject } from '~/packages/geo/community/communityObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import { latitude, longitude } from '~/prix/types/presets/geo'

export const alertObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid().nullish(),
  clientId: z.number().nullish(),
  residenceClientId: z.string().nullish(),
  residence: residenceObject.nullish(),
  code: z.number().nullish(),
  plusCode: z.string(),
  title: z.string().nullish(),
  observation: z.string().nullish(),
  latitude: latitude(),
  longitude: longitude(),
  accuracy: z.number().nullish(),
  radiusMeters: z.number().min(100),
  communityId: z.string().uuid().nullish(),
  community: communityObject.nullish(),
  buildingId: z.number().nullish(),
  fullAddress: z.string().nullish(),
  classification: enumerated({
    informative: 'Informativo',
    emergency: 'Emergencial',
  }).nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  interruptedAt: dateOrIsoString().nullish(),
  validUntil: dateOrIsoString().nullish(),
  sourceFilter: z.string().nullish(),
  communityName: z.string().nullish(),
})

export const classificationMap = {
  informative: 'Informativo',
  emergency: 'Emergencial',
}

export type AlertType = z.infer<typeof alertObject>
